<div class="container-fluid" *ngIf="location && locationId">
  <mat-toolbar color="primary">
    <button mat-icon-button (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>{{ location.name }}</span>
    <span class="spacer"></span>
    <button mat-icon-button (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-toolbar>

  <mat-card appearance="outlined" class="mt-4">
    <mat-card-content>
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
        
        <mat-tab label="Branding">
          <div class="tab-content">
            <app-location-branding [locationId]="locationId"></app-location-branding>
          </div>
        </mat-tab>

        <mat-tab label="Horarios">
          <div class="tab-content">
            <app-location-schedule [locationId]="locationId"></app-location-schedule>
          </div>
        </mat-tab>

        <mat-tab label="Excepciones">
          <div class="tab-content">
            <app-location-exceptions [locationId]="locationId"></app-location-exceptions>
          </div>
        </mat-tab>

        <mat-tab label="Vacaciones">
          <div class="tab-content">
            <app-location-vacations [locationId]="locationId"></app-location-vacations>
          </div>
        </mat-tab>

        <mat-tab label="Bloqueos">
          <div class="tab-content">
            <app-location-blocks [locationId]="locationId"></app-location-blocks>
          </div>
        </mat-tab>

      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>

<div class="container-fluid" *ngIf="!location && !(isLoading$ | async)">
  <mat-card appearance="outlined">
    <mat-card-content>
      <p>No se encontró el centro de trabajo solicitado.</p>
      <button mat-raised-button color="primary" (click)="onBack()">
        Volver a la lista
      </button>
    </mat-card-content>
  </mat-card>
</div>

<div class="container-fluid" *ngIf="isLoading$ | async">
  <div class="loading-container">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
  </div>
</div>
